// Consumer SMS conversation calls — same endpoints and params as the Android technician app's
// InboxConversationFragment (api/v3/pro/inbox/sms/*). Every call resolves to { ok, body, paging, message }, never throws.
import { apiCall } from "./apiCall";

export const SMS_PAGE_LIMIT = 20;

export const smsApi = {
  // newest first (desc); page 1 = latest messages, higher pages = older
  conversation: (companyConsumerId, page = 1, { silent = true } = {}) => apiCall("post", `inbox/sms/conversation/${companyConsumerId}`, {
    limit: SMS_PAGE_LIMIT,
    page,
    search: "",
    sort: { column: "sent_at", direction: "desc" },
  }, { silent }),
  // { can_send_sms, from_phones: [{ title, value }] }
  config: ({ silent = true } = {}) => apiCall("post", "inbox/sms/conversation/config", {}, { silent }),
  // user action: shows the global loader
  send: (companyConsumerId, fromPhoneId, text) => apiCall("post", `inbox/sms/conversation/send/${companyConsumerId}`, {
    from_phone_id: Number(fromPhoneId),
    text,
  }),
};
